// extracted by mini-css-extract-plugin
export default {"cartTotal":"CartTotal_cartTotal__hzTS3","cartTotal__total":"CartTotal_cartTotal__total__rjomD","cartTotal__amount":"CartTotal_cartTotal__amount__+aX5u"};